import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { routes } from '../../../constants'
import { actions } from '../marcador.actions'
import { MarcadorForm } from './MarcadorForm'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import utils from '../../../utils'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  return {
    record: state.crudMarcadorState.currentRecord,
    messages: state.crudMarcadorState.messages,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let value = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, value))
    },
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
  }
}

class MarcadorFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }

  componentWillUnmount() {
    this.props.clearSelectedFilters()
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_MARCADOR}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  buildHeader = () => {
    if (utils.nonNull(this.props.renderToolbar) && !this.props.renderToolbar) {
      // não deve mostrar a toolbar caso esteja sendo adicionado de um contrato
    } else {
      return <DefaultFormToolBar formPageContainer={this} />
    }
  }

  render() {
    const content = (
      <MarcadorForm
        record={this.props.record}
        changeHandler={this.props.changeHandler}
        messages={this.props.messages}
        history={this.props.history}
        setField={this.props.setField}
      />
    )
    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MarcadorFormPageContainer)
